export default {
  mounted(el) {
    const persianRegex = /[\u0600-\u06FF\u0750-\u077F]/;

    const setDirection = (text) => {
      const sample = text?.trim() || "";
      const dir = persianRegex.test(sample) ? "rtl" : "ltr";
      el.setAttribute("dir", dir);
      el.style.textAlign = dir === "rtl" ? "right" : "left";
    };

    // 🔹 Initial detection (if input already has a value)
    setDirection(el.value);

    // 🔹 Every time the value changes
    el.addEventListener("input", (e) => {
      setDirection(e.target.value);
    });
  },

  updated(el) {
    // 🔹 When the value is updated from outside (such as v-model from parent)
    const persianRegex = /[\u0600-\u06FF\u0750-\u077F]/;
    const sample = el.value?.trim() || "";
    const dir = persianRegex.test(sample) ? "rtl" : "ltr";
    el.setAttribute("dir", dir);
    el.style.textAlign = dir === "rtl" ? "right" : "left";
  },
};
